import createVueComponent from '../createVueComponent';

const MinusCircle = createVueComponent('MinusCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M8 12h8', key: '1wcyev' }],
]);

export default MinusCircle;
